import { OrderedMap } from 'immutable';
import type { ID, ReduxAction, ContactPermission, ContactSubPermission } from '@repo/utils/types';
import { selectSelectedContact } from '../../../actions/ui';
import AppState from '../../app-state';
import { Sharee } from '@repo/utils/models/Sharee';
import { addShareePermission, shareesFromProps, ShareStatus } from '@repo/utils/models/ShareStatus';
import {
  createShareeRequested,
  createShareeSucceeded,
  deleteShareePermissionRequested,
  fetchAllShareesSucceeded,
  updatePublicSharingRequested,
} from './utils';

export const labelForContactPermission: Record<ContactSubPermission, string> = {
  view_contact_notes: 'Notes',
  view_contact_moments: 'Moments',
  view_contact_contactinfo: 'Sources',
};

export const supportedContactPermissions: ContactSubPermission[] = [
  'view_contact_notes',
  'view_contact_moments',
  'view_contact_contactinfo',
];

export class ContactSharee extends Sharee<ContactPermission> {
  constructor(props) {
    super(props);
  }

  get idForMainPermission(): ID {
    return this.idForPermission('view_contact');
  }
}

export class ContactShareStatus extends ShareStatus<ContactPermission> {
  constructor(props: any = {}) {
    super(props);
    this.sharees = shareesFromProps(ContactSharee, props);
  }

  addShareePermission = addShareePermission.bind(this, ContactSharee);
}

export type ContactShareStatusesState = OrderedMap<ID, ContactShareStatus>;
const initialContactsShareStatusesState = OrderedMap<ID, ContactShareStatus>();

/* Selectors */
export const selectSelectedContactShareStatus = (state: AppState) =>
  state.data.shareStatuses.contacts.get(selectSelectedContact(state).id, new ContactShareStatus());

export const selectContactShareStatus = (contactID: ID) => (state: AppState) =>
  state.data.shareStatuses.contacts.get(contactID, new ContactShareStatus());

export function contactShareStatusesReducer(
  state: ContactShareStatusesState = initialContactsShareStatusesState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'FETCH_ALL_CONTACT_SHAREES_SUCCEEDED':
      return fetchAllShareesSucceeded(state, payload, ContactShareStatus);

    case 'UPDATE_PUBLIC_CONTACT_SHARING_REQUESTED':
      return updatePublicSharingRequested(state, payload);

    case 'CREATE_CONTACT_SHAREE_REQUESTED':
      return createShareeRequested(state, payload);

    case 'CREATE_CONTACT_SHAREE_SUCCEEDED':
      return createShareeSucceeded(state, payload, ContactSharee);

    case 'DELETE_VERIFIED_CONTACT_SHAREE_PERMISSION_REQUESTED':
    case 'DELETE_WAITING_CONTACT_SHAREE_PERMISSION_REQUESTED':
      return deleteShareePermissionRequested(state, payload);

    default:
      return state;
  }
}
